import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(
    public _snackBar: MatSnackBar,
    public translateService:TranslateService

  ) { }



  addedSnackBar(flag:any,serviceName:any) {
    this._snackBar.open(`${serviceName} ${flag ? this.translateService.instant('pages.home.L.addedToFav'):this.translateService.instant('pages.home.L.removeToFav')}`, '', {
      duration: 4000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }
  
  addedBookmark(flag:any,serviceName:any, length?:any) {
    if(length >= 5) {
      this._snackBar.open(`${ this.translateService.instant('schemes.bookmarkLimitError')}`, '', {
        duration: 4000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
    } else {
    this._snackBar.open(`${serviceName} ${flag ? this.translateService.instant('schemes.addedToBookmark'):this.translateService.instant('schemes.removedFromBookmark')}`, '', {
      duration: 4000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }
  }
}
